import React from 'react';
import translate from '../translate';
import WOW from 'wowjs';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

function ServiceDetails() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'serviceDetails';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="details-page team-details-page service-details-page pt-130 pb-130">
        <div className="container">
            <div className="row">
                <div className="col-xl-8">
                    <div className="details-wrapper pr-25">
                        <div className="details-thumb">
                            <img src="assets/img/servicedetails/process.webp" alt="img"/>
                        </div>
                        <div id="service1" className="details-content mt-60">
                            <h2 className="title mb-25">{translate(componentName, 'service1Title', language)}</h2>
                            <p>{translate(componentName, 'service1Description', language)}</p>
                        </div>
                        <div id="service2" className="details-content mt-60">
                            <h2 className="title mb-25">{translate(componentName, 'service2Title', language)}</h2>
                            <p>{translate(componentName, 'service2Description', language)}</p>
                        </div>
                        <div id="service3" className="details-content mt-60">
                            <h2 className="title mb-25">{translate(componentName, 'service3Title', language)}</h2>
                            <p>{translate(componentName, 'service3Description', language)}</p>
                        </div>
                        <div id="service4" className="details-content mt-60">
                            <h2 className="title mb-25">{translate(componentName, 'service4Title', language)}</h2>
                            <p>{translate(componentName, 'service4Description', language)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4">
                    <div className="blog_sidebar service-sidebar mt-none-60">
                        <div className="blog_widget widget mt-60 widget_categories">
                            <h2 className="blog-widget-title">{translate(componentName, 'servicesSidebarTitle', language)}</h2>
                            <ul className="list-unstyled">
                                <li className="cat-item"><a href="#service1">{translate(componentName, 'service1', language)}</a><span className="count">01</span></li>
                                <li className="cat-item"><a href="#service2">{translate(componentName, 'service2', language)}</a><span className="count">02</span></li>
                                <li className="cat-item"><a href="#service3">{translate(componentName, 'service3', language)}</a><span className="count">03</span></li>
                                <li className="cat-item"><a href="#service4">{translate(componentName, 'service4', language)}</a><span className="count">04</span></li>
                            </ul>
                        </div>
                        <div className="blog_widget widget mt-40">
                            <h2 className="blog-widget-title">{translate(componentName, 'getQuoteTitle', language)}</h2>
                            <div className="input-field">
                                <form action="/home" method="get">
                                    <input type="text" name="name" id="name" placeholder={translate(componentName, 'getQuoteNamePlaceholder', language)}/>
                                    <input type="email" name="mail" id="mail" placeholder={translate(componentName, 'getQuoteEmailPlaceholder', language)}/>
                                    <textarea name="message" id="message" placeholder={translate(componentName, 'getQuoteMessagePlaceholder', language)}></textarea>
                                    <button type="submit" className="btn mt-30">{translate(componentName, 'getQuoteSubmitButton', language)} <span></span></button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default ServiceDetails;